/**************************************************************************************************************
    For a list of available material design icons, see: https://fonts.google.com/icons?selected=Material+Icons

    Usage: <material-design-svg
        data-icon="<outlined|filled|rounded|sharp|towTone|>__<icon name in snake case>"
        data-width="<width>"  // sets the width of the svg element
        data-height="<height>"  // sets the height of the svg element
        data-icon-size="100"  // sets the size of the icon
        data-icon-color="<color>"  // sets the color of the icon, can be hex or named color
        data-viewbox="x y dx dy">  // sets the viewbox attribute of the svg element
    </material-design-svg>

    Example: <material-design-svg data-icon="outlined__fast_forward" data-icon-size="100"></material-design-svg>

    Note: The data-icon attribute is required.  The data-icon-size attribute is required if you want to see the icon.

    Edit this file to include the icons you want to use.  The icons are stored in the buttonIcons object.  The key
    is the data-icon attribute value.  The value is the svg file.  The svg file is fetched from the material design
    icons repository.  The svg file is then parsed and the svg element is created.  The svg element is then appended
    to this element.  This element is then removed from the DOM.

**************************************************************************************************************/

import OutlinedFastForward from '@material-design-icons/svg/outlined/fast_forward.svg';
import OutlinedFastRewind from '@material-design-icons/svg/outlined/fast_rewind.svg';
import OutlinedPlayArrow from '@material-design-icons/svg/outlined/play_arrow.svg';
import FilledCircle from '@material-design-icons/svg/filled/circle.svg';
import FilledThumbUp from '@material-design-icons/svg/filled/thumb_up.svg';
import FilledThumbDown from '@material-design-icons/svg/filled/thumb_down.svg';
import OutlinedArrowBack from '@material-design-icons/svg/outlined/arrow_back.svg';
import OutlinedDownloadForOffline from '@material-design-icons/svg/outlined/download_for_offline.svg';
import FilledArrowDropDown from '@material-design-icons/svg/filled/arrow_drop_down.svg';
import OutlinedDownload from '@material-design-icons/svg/outlined/download.svg'; 
import OutlinedTeleradReports from '../../../../images/svg/telerad_docs.svg';
import OutlinedAIReports from '../../../../images/svg/ai_docs.svg';


const buttonIcons = {
    'outlined__fast_forward': OutlinedFastForward,
    'outlined__fast_rewind': OutlinedFastRewind,
    'outlined__play_arrow': OutlinedPlayArrow,
    'filled__circle': FilledCircle,
    'filled__thumb_up': FilledThumbUp,
    'filled__thumb_down': FilledThumbDown,
    'outlined__download_for_offline': OutlinedDownloadForOffline,
    'outlined__telerad_reports': OutlinedTeleradReports,
    'outlined__ai_reports': OutlinedAIReports,
    'outlined__arrow_back': OutlinedArrowBack,
    'outlined__download': OutlinedDownload,
    'filled__arrow_dropdown': FilledArrowDropDown
};

export class MaterialDesignSvg extends HTMLElement
{
    constructor ()
    {
        super();
    }

    connectedCallback ()
    {
        this.init();
    }

    init ()
    {
        this.createPath();
    }

    createPath ()
    {
        if (this.dataset.icon === undefined) {
            console.error('MaterialDesignPath: Missing data-icon attribute');
            throw new Error('MaterialDesignPath: Missing data-icon attribute');
        }

        const icon = buttonIcons[this.dataset.icon];
        fetch(icon) // Get the contents of the SVG file
        .then(response => response.text())
        .then(svgData => {
            const svgContainer= document.createElement('div');
            svgContainer.innerHTML = svgData;
            const svgElem = svgContainer.querySelector('svg');

            // got our svg element.  Stet the children and attributes with those of this element
            while (this.firstChild) {
                const child = this.firstChild;
                const svgChild = document.createElementNS('http://www.w3.org/2000/svg', child.tagName);
                svgElem.appendChild(svgChild);
                svgChild.outerHTML = child.outerHTML;
                this.removeChild(child);
            }

            for (let i = 0; i < this.attributes.length; i++) {
                const attr = this.attributes[i];
                if (attr.name === 'viewbox') {
                    svgElem.setAttributeNS('viewBox', attr.value);
                } else {
                    svgElem.attributes.setNamedItem(attr.cloneNode());
                }
            }

            // apply styles
            for (let i = this.style.length - 1; i >= 0; i--) {
                const style = this.style[i];
                svgElem.style[style] = this.style[style];

            }

            // now replace this with our new svg element
            this.parentNode.replaceChild(svgElem, this);
        });

    }
}

customElements.define('material-design-svg', MaterialDesignSvg);